import { render } from "./MenuContentItemSelectionWizard.vue?vue&type=template&id=5831b7ee"
import script from "./MenuContentItemSelectionWizard.vue?vue&type=script&lang=js"
export * from "./MenuContentItemSelectionWizard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__